import React from "react";

import { StrainsShallow } from "@/custom-types/Shop";
import { Strain } from "@/custom-types/Strain";

import Image from "@/components/Image";

type LeaflyNugStrain = Strain | StrainsShallow;
type Props = {
  strain: LeaflyNugStrain;
  showSvg?: boolean;
};

// Copied from FEC as it wasn't exported
const LeaflyNug: React.FC<Props> = ({ strain }) => {
  const getNugImage = (strain: LeaflyNugStrain): string | null | undefined =>
    strain.nugImage ??
    ("stockNugImage" in strain ? strain.stockNugImage : undefined);

  const image = (strain: LeaflyNugStrain) => {
    return (
      <>
        <div className="absolute bottom-0 top-0" data-testid="NugImage">
          <Image alt="Nug Image" sizes={[75]} src={getNugImage(strain) || ""} />
        </div>
      </>
    );
  };

  return (
    <div
      style={{
        flex: "none",
        height: "85px",
        position: "relative",
        width: "80px",
      }}
    >
      {image(strain)}
    </div>
  );
};

export default LeaflyNug;
